<template>
  <div class="recipe_add">
         <br/>

    <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>药品查询</el-breadcrumb-item>
    </el-breadcrumb>

    <hr />

    <el-container>
    <!-- <el-header>空置区域 </el-header> -->
    <el-main>
        <el-form ref="form" :model="form" label-width="200px">
        <table width="100%">
            <tr>
                <td>
                    <el-form-item label="处 方 药">
                        <el-input v-model="formModels.medicineName" placeholder="请输入药品名称"></el-input>
                    </el-form-item>
                </td>
                <td>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查询</el-button>
                    </el-form-item>
                </td>
            </tr>
            <tr>
                <td>

                </td>
                <td>
                    <el-form-item>
                        <el-button @click="DrugAdd">新增药品</el-button>
                        <el-button @click="importExcel">Excel 导入</el-button>
                    </el-form-item>
                </td>
            </tr>
            </table>
            </el-form>

        <div class="form-region-header font-30"><!-- 表格上方标题文字占位 --></div> 
        <table width="100%">
            <tr>
                <td>
                    <el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column
                        type="selection"
                        width="55">
                        </el-table-column>
                        <el-table-column prop="name" label="药品" width="180">
                        </el-table-column>
                        <el-table-column prop="speci" label="规格" width="180">
                        </el-table-column>
                        <el-table-column prop="price" label="单价">
                        </el-table-column>
                        <el-table-column prop="width" label="药盒宽度">
                        </el-table-column>
                        <el-table-column prop="length" label="药盒长度">
                        </el-table-column>
                        <el-table-column prop="code" label="药品条形码">
                        </el-table-column>
                        <el-table-column prop="createddate" label="创建时间">
                        </el-table-column>
                        <el-table-column prop="operation" label="操作">
                        </el-table-column>
                    </el-table>
                </td>
            </tr>
            </table>
                <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-size="100"
                layout="total, prev, pager, next"
                :total="1000">
            </el-pagination>
    </el-main>
    </el-container>


  </div>
</template>

<script>
export default {
  name: 'AddDrug',
  data() {
      return {
        activeName: 'first',

        currentPage: '0',
        formModels: {
            orderDate: '',
        },
        formBinds: {
        },
        auditApi: 'http://www,google.com',
        rules: {
          name: [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
            { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
          ],
          medicine: [
            { required: true, message: '请选择药品名字', trigger: 'change' }
          ],
        },

      }
    },
  props: {
    msg: String,
  },
  methods: {
      DrugAdd() {
          this.$router.replace("/DrugAdd");
      },
      importExcel() {
            this.$router.replace("/ExcelEdit");
      },
    addDrug(formName) {
      console.log(formName)
      this.$confirm('是否同意?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            this.axios
            .get(this.DoctorApprovalApi)
            .then(response => (this.info = response.data))
            .catch(function(err) {
                alert(err);
            });
        }).catch(() => {
          //this.$message({
          //  type: 'info',  // success
          //  message: '已取消删除'
          // });          
        });
    },

    // importExcel(formName) {
    //   console.log(formName)
    //   this.$confirm('是否同意?', '提示', {
    //       confirmButtonText: '确定',
    //       cancelButtonText: '取消',
    //       type: 'warning'
    //     }).then(() => {
    //         this.axios
    //         .get(this.DoctorApprovalApi)
    //         .then(response => (this.info = response.data))
    //         .catch(function(err) {
    //             alert(err);
    //         });
    //     }).catch(() => {
    //       //this.$message({
    //       //  type: 'info',  // success
    //       //  message: '已取消删除'
    //       // });          
    //     });
    // },
    // 分页相关
    handleSizeChange(val) {
    console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        console.log(`当前页: ${val}`);
    },

    // 复选框相关
    toggleSelection(rows) {
        if (rows) {
          rows.forEach(row => {
            this.$refs.multipleTable.toggleRowSelection(row);
          });
        } else {
          this.$refs.multipleTable.clearSelection();
        }
      },
    handleSelectionChange(val) {
    this.multipleSelection = val;
    },
  },
  mounted () {
    if (sessionStorage.getItem("authToken") == null||sessionStorage.getItem("authToken").trim()==""){
      this.$router.replace("/Login");
    }
  }
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

</style>
